import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import { ReactNode, useState } from 'react';
import { useTheme } from 'styled-components';
import DownloadsMenuItem from 'components/Widget/DownloadsMenuItem';
import Icon, { IconType } from 'components/Icon';
import * as S from './styles';

interface Props {
	children: ReactNode;
}

const ExportDropdown = ({ children }: Props) => {
	const theme = useTheme();
	const [open, setOpen] = useState(false);

	return (
		<RadixDropdown.Root open={open} onOpenChange={setOpen}>
			<S.Trigger>
				Export
				<S.Chevron $open={open}>
					<Icon type={IconType.FILLED_ARROW_DOWN} width={12} height={12} color={theme.gray[0]} />
				</S.Chevron>
			</S.Trigger>
			<RadixDropdown.Portal>
				<S.Content side="bottom" sideOffset={8} align="end">
					{children}
					<DownloadsMenuItem />
				</S.Content>
			</RadixDropdown.Portal>
		</RadixDropdown.Root>
	);
};

export default ExportDropdown;
